import utils from '@/store/utils'

export default {
    state: {
        showOnboarding: true
    },
    mutations: {
        SET_SHOW_ONBOARDING: utils.set('showOnboarding')
    }
}
